import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core'
import { BaseComponent } from 'common/helpers'
import { MediaBrowserSelection } from 'media/services/mediaBrowserSelection.service'
import { MediaFile, MediaFileBundle, MediaRoot } from 'elements-sdk'

@Component({
  selector: 'media-bundle-item',
  templateUrl: './mediaBundleItem.component.pug',
  styleUrls: ['./mediaBundleItem.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediaBundleItemComponent extends BaseComponent {
  @Input() bundle: MediaFileBundle
  @Input() location?: MediaFile
  @Input() root?: MediaRoot
  @Input() showRating = true
  @Input() selectable = true
  @Output() onSelect = new EventEmitter<MouseEvent>()

  constructor (
    private cdr: ChangeDetectorRef,
    public mediaBrowserSelection: MediaBrowserSelection,
  ) {
    super()
    this.subs.add(this.mediaBrowserSelection.change$.subscribe(() => cdr.markForCheck()))
  }

  get name (): string {
    if (this.root?.nameField) {
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      return this.bundle.asset?.customFields[this.root.nameField] || this.bundle.name
    }
    return this.bundle.name
  }

  onCheckbox (event: MouseEvent) {
    this.onSelect.emit(event)
    event.stopPropagation()
  }
}
